<template>

    <div class="userInfo-wrapper"
         v-if="order.finance.express && order.type != params.TYPE_TRY_OUT">
        <div class="userInfo-border">
            <h5>物流信息
                <el-button size="mini" type="primary" v-if="Acs('/order/add-sending') && !order.close_audit"  @click="showLogisticDialog">添加寄件内容
                </el-button>
            </h5>
            <el-row class="userInfo-group">
                <el-table :data="order.logistics" center style="width: 100%" v-loading="loading">
                    <el-table-column prop="id" label="寄件ID"></el-table-column>
                    <el-table-column prop="goods_type_str" label="寄件类型"></el-table-column>
                    <el-table-column prop="send_at" label="寄出日期"></el-table-column>
                    <el-table-column prop="express_content" label="寄件备注"></el-table-column>
                    <el-table-column prop="send_type_str" label="送达方式"></el-table-column>
                    <el-table-column prop="send_way_str" label="寄件快递"></el-table-column>
                    <el-table-column prop="express_way_str" label="寄件方式"></el-table-column>
                    <el-table-column prop="express_no" label="快递单号"></el-table-column>
                    <el-table-column prop="express_status_str" label="签收状态"></el-table-column>
                    <el-table-column prop="operate" label="操作" width="120">
                        <template slot-scope="scope">
                            <div>
                                <el-button type="text" v-if="Acs('/order/add-sending')" @click="editContent(scope.row)" size="small">编辑内容</el-button>
                                <el-button type="text" v-if="Acs('/order/add-sending')" @click="deleteLogistic(scope.row)" size="small">删除</el-button>
                            </div>
                            <div>
                                <el-button type="text" v-if="Acs('/order/add-logistics') && scope.row.send_type != 2" @click="editLogistic(scope.row)" size="small">录入物流信息</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>
        </div>
        <LogisticsForm v-if="dialog_type > 0" 
            :dialog_type="dialog_type" 
            :params="logisticsForm" 
            @updateChange="handleUpdate" 
            @addChange="handleAdd" 
            @close="handleCloseDialog"
            @addExpress="addExpress">
        </LogisticsForm>
    </div>
</template>
<script>
    import {OrderMixin} from "~/services/OrderMixin";
    import OrderService from "~/services/order";
    import CustomerService from "~/services/customer"
    import LogisticsForm from "~/views/order/dialog/LogisticsForm.vue";

    export default {
        components: {
            LogisticsForm
        },

        mixins:[OrderMixin],
        
        props:{
            order:{
                required: true
            },
        },
        data(){
            return {
                logisticsForm: {
                    order_id: this.$route.query['id'],
                },
                loading: false,
                dialog_type: 0,
            }
        },
        created() {
        },
        methods:{
            editLogistic(row){
                this.logisticsForm = Object.assign(this.logisticsForm, row);
                if(this.logisticsForm.express_way == 0) this.logisticsForm.express_way = '';
                this.dialog_type = 1;
            },
            editContent(row){
                this.logisticsForm = Object.assign(this.logisticsForm, row);
                this.dialog_type = 2;
            },
            deleteLogistic(item){
                this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    OrderService.logisticsDel(item.id).then(res => {
                        if (res.code == 0) {
                            this.order.logistics = this.order.logistics.filter(i=>{
                                return i.id != item.id;
                            })
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                        }
                    })
                }).catch(() => {
                });
            },


            showLogisticDialog() {
                this.dialog_type = 2;
                // this.getLastExpress(this.order.customer_id);
            },

            getLastExpress(customerId) {
                CustomerService.getLastExpress(customerId).then(res => {
                    if (res.code == 0 && res.data.id) {
                        this.logisticsForm = {
                            order_id: this.order.id,
                            goods_type: res.data.goods_type,
                            send_at: res.data.send_at,
                            send_type: res.data.send_type > 0 ? res.data.send_type : '',
                            send_way: res.data.send_way,
                            express_content: res.data.express_content,
                            sender: this.$store.getters.name,//寄件人
                        };
                    }
                    this.dialog_type = 2;
                }).catch(err => {
                    this.dialog_type = 2;
                })
            },

            handleAdd(data){
                this.order.logistics.push(data);
            },

            handleUpdate(data){
                // 查找需要更新的物流信息的索引
                let index = this.order.logistics.findIndex(i => i.id === data.id);

                // 如果找到了，就更新该物流信息
                if (index !== -1) {
                    // 使用 this.$set 确保响应性更新
                    this.$set(this.order.logistics, index, { ...this.order.logistics[index], ...data });
                }
            },
            
            handleCloseDialog(){
                this.dialog_type = 0;
            },

            addExpress(data){
                this.order.finance.express.push(data);
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/partial/order_logistic.vue